import { render } from "./App.vue?vue&type=template&id=180a4543&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=180a4543&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=180a4543&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Documents\\Personal\\adeebxhannaslideshow\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180a4543"]])

export default __exports__